import React from 'react'
import ReactDOM from 'react-dom'

// React components
import App from './scripts/components/App'

/*
  STYLES
*/

// Libraries
import './styles/libs/reset.css'
import './styles/libs/bootstrap-grid.min.css'

// Core
import './styles/App.css'

// Modules
import './styles/modules/button.css'
import './styles/modules/close.css'
import './styles/modules/generator.css'
import './styles/modules/headline.css'
import './styles/modules/landing-page.css'
import './styles/modules/sandwich.css'

ReactDOM.render(
    <App />, 
    document.getElementById('app')
)


// WEBPACK FOOTER //
// ./src/index.js